import {
  useState,
  useContext,
  createContext,
  type Dispatch,
  type SetStateAction,
  type HTMLProps,
} from 'react';

type ConnectProps = HTMLProps<HTMLDivElement>;

type ConnectContextProps<T = unknown> = {
  values: null | T;
  setValues: null | Dispatch<SetStateAction<null | T>>;
};

const ConnectContext = createContext<null | ConnectContextProps>({
  values: null,
  setValues: null,
});

const Connect = ({children}: ConnectProps) => {
  const [values, setValues] = useState<null | unknown>();

  return (
    <ConnectContext.Provider value={{values, setValues}}>
      {children}
    </ConnectContext.Provider>
  );
};

export const useConnect = <T,>() => {
  return useContext(ConnectContext) as ConnectContextProps<T>;
};

export default Connect;
